import { NgModule } from '@angular/core';
import { LibCreditCardsIconComponent } from './lib-credit-cards-icon.component';

@NgModule({
  declarations: [LibCreditCardsIconComponent],
  imports: [],
  exports: [LibCreditCardsIconComponent],
})
export class LibCreditCardsIconModule {}
